/**
 * Split a visibility target into cards that stay full and cards that wait.
 * Already-full cards and interaction pins upgrade immediately. Everyone else
 * queues so a pan settle does not mount a whole band in one commit.
 */
export function planCardTiers(prevFull, target) {
  const full = new Set();
  const queue = [];
  const immediate = target.immediate || new Set();
  target.full.forEach((id) => {
    if (prevFull.has(id) || immediate.has(id)) full.add(id);
    else queue.push(id);
  });
  return { mounted: target.mounted, full, queue };
}

/**
 * While the camera is moving, cards already on the canvas stay mounted and stay full.
 * Missions that have entered the view wait in a queue. On-screen cards come before
 * padding silhouettes. The caller mounts the queue later, off the pan frame.
 */
export function planPanCatchUp(prevMounted, prevFull, target) {
  const queue = [];
  const seen = new Set();
  const push = (id) => {
    if (seen.has(id)) return;
    seen.add(id);
    queue.push(id);
  };

  const immediate = target.immediate || new Set();
  immediate.forEach((id) => {
    if (!prevMounted.has(id) || !prevFull.has(id)) push(id);
  });
  target.full.forEach((id) => {
    if (!prevMounted.has(id) || !prevFull.has(id)) push(id);
  });
  target.mounted.forEach((id) => {
    if (!prevMounted.has(id)) push(id);
  });

  return {
    mounted: new Set(prevMounted),
    full: new Set(prevFull),
    queue,
  };
}

/**
 * Add a catch-up batch. Ids in the full or immediate set become real cards.
 * Everyone else in the batch mounts as a silhouette. Nothing already up is removed.
 */
export function commitPanCatchUpBatch(prevMounted, prevFull, batch, target) {
  const mounted = new Set(prevMounted);
  const full = new Set(prevFull);
  const immediate = target.immediate || new Set();
  batch.forEach((id) => {
    mounted.add(id);
    if (target.full.has(id) || immediate.has(id)) full.add(id);
  });
  return { mounted, full };
}
